import { useEffect } from 'react';
import { datadogRum, Site } from '@datadog/browser-rum';
import { useAppConfig } from '../../components/AppConfigContext';

export const useDataDogRUM = (): void => {
  const {
    datadogAppID,
    datadogClientToken,
    datadogEnabled,
    datadogEnv,
    datadogSite,
  } = useAppConfig();

  useEffect(() => {
    if (!datadogEnabled) {
      return;
    }

    datadogRum.init({
      service: 'checkout',
      applicationId: datadogAppID,
      clientToken: datadogClientToken,
      site: datadogSite as Site,
      env: datadogEnv,
      profilingSampleRate: 1,
      traceSampleRate: 10,
      telemetrySampleRate: 20,
      usePartitionedCrossSiteSessionCookie: true,
      silentMultipleInit: true,
      trackUserInteractions: true,
    });
  }, []);
};
